import { Service } from '@roc/client-portal-shared/services';

const url = {
  GET_SIGNING_INFO:
    '/nportal/rest/pub/loanExtension/getExtensionSigningInfo?token=',
  GENERATE_EXTENSION_AGREEMENT:
    '/nportal/rest/pub/signing/generateExtensionAgreementDocument',
};

export class ExtensionAgreementSigningService extends Service {
  getExtensionSigningInfo(token: string) {
    return this.get(`${url.GET_SIGNING_INFO}${encodeURIComponent(token)}`);
  }

  generateExtensionAgreementDocument(data) {
    return this.post(url.GENERATE_EXTENSION_AGREEMENT, data);
  }
}
